import { render } from "./card-status-claim.vue?vue&type=template&id=48160281&ts=true"
import script from "./card-status-claim.vue?vue&type=script&lang=ts"
export * from "./card-status-claim.vue?vue&type=script&lang=ts"

import "./card-status-claim.vue?vue&type=style&index=0&id=48160281&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__